/**
 * Seasonal warehouse sale life switch
 */ export var SEASONAL_WAREHOUSE_SALE_ENABLED = 'SEASONAL_WAREHOUSE_SALE_ENABLED';
